import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { RecentBlog } from '../core/RecentBlog';
import { SearchForm } from '../core/SearchForm';
import { HotelBedData } from '../shared/index';
import { CancelationsRequest } from './CancelationsRequest';
import { ContactUs } from './ContactUs';
import { FAQs } from './FAQs';
import { ModificationBooking } from './ModificationBooking';
import { News } from './News';
// import { PrivacyPolicy } from './PrivacyPolicy';
import { Sitemap } from './Sitemap';
// import { TermsOfUse } from './TermsOfUse';
import { SettlementEnquiryThankyouPage } from './SettlementEnquiryThankyouPage';
import { getStaticPage } from '../utils/index';
import { PageMaster } from './PageMaster';
import { scrollToTop } from 'src/core';
export interface StaticContentIndexProps extends BaseComponentProps {
    lang: string;
    slug: string;
    history?: History | any;
    externalFilter: HotelBedData.ExternalFilter;
    getHotels: (lang: string, page: number, count: number, filter: HotelBedData.SearchFilter, externalFilter: HotelBedData.ExternalFilter) => any;
    /** 
     * filter awal untuk data
     */
    initialFilter: HotelBedData.SearchFilter | undefined;
}

export interface StaticContentIndexState extends BaseComponentState { 
    masterPage?: string | undefined;
}

export class StaticContentIndex extends BaseComponent<StaticContentIndexProps, StaticContentIndexState> {

    constructor(props: StaticContentIndexProps) {
        super(props);
    }

    componentWillMount() {
        scrollToTop();
    }

    componentDidMount() {
        getStaticPage(this.props.lang, this.props.history.location.pathname).then(
            e => { 
                // console.log("Static Content", e);
                this.setState({masterPage: e});
            }
        ).catch(
            err => {
                console.log("Static Content Error", err);
                this.setState({masterPage: "<span/>"});
            }
        ); 
    }

    render() {
        if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
        let page = <span />;
        let title = '';
        switch (this.props.slug) { 
            case 'news':
                title = 'About Bali ';
                page = <News lang={this.props.lang} history={this.props.history} />;
                break;
            case 'contact-us':
                title = 'Contact Us';
                page = <ContactUs lang={this.props.lang} history={this.props.history} />;
                break;
            case 'request-cancelation':
                title = 'Cancelation Request';
                page = <CancelationsRequest lang={this.props.lang} history={this.props.history} />;

                break;
            case 'privacy-policy':
                title = 'Privacy Policy';
                // page = <PrivacyPolicy lang={this.props.lang} history={this.props.history} />;
                page = (<PageMaster  lang={this.props.lang}  content={this.state.masterPage} />);
                break;
            case 'modification-booking':
                title = 'Modification Booking';
                page = <ModificationBooking lang={this.props.lang} history={this.props.history} />;

                break;
            case 'terms-of-use':
                title = 'Terms Of Use ';
                // page = <TermsOfUse lang={this.props.lang} history={this.props.history} />; 
                page = (<PageMaster  lang={this.props.lang}  content={this.state.masterPage} />);
                break;
            case 'sitemap':
                title = 'Sitemap ';
                page = <Sitemap lang={this.props.lang} history={this.props.history} />;

                break;
            case 'faqs':
                title = 'Frequently Asked Questions ';
                page = <FAQs lang={this.props.lang}  />;
                // page = (<PageMaster  lang={this.props.lang}  content={this.state.masterPage} />);
                break;
            case 'settlement-thankyou':
                title = 'Thank you';
                page = <SettlementEnquiryThankyouPage lang={this.props.lang}  />; 
                break;
            default:
                page = <span />;
                break;
        }

        return (
            <div style={{ paddingBottom: 20 }}>
                <div style={{ paddingTop: 150, paddingBottom: 20, background: '#373839' }}>
                    <h1 className="center" style={{ color: "white" }}>{title}</h1>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-9" style={{ marginTop: 15, background: '#fff', border: '1px solid #eee', padding: 15 }}>
                            {page}
                        </div>
                        <div className="col-md-3" style={{ marginTop: 15 }}>
                            <h3>Search Hotel</h3>
                            <SearchForm
                                lang={this.props.lang}
                                showtitle={false}
                                style='vertical'
                                count={15}
                                getHotels={this.props.getHotels}
                                externalFilter={this.props.externalFilter}
                                filter={this.props.initialFilter!}
                                /* key={btoa(JSON.stringify(this.props.initialFilter))} */
                            />
                            <RecentBlog lang={this.props.lang} />
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/static-content/StaticContentIndex.tsx